import axiosInstance from "@/common/axiosInstance";
import apiCall from "./apiCall";
import apiCallStandard from "./apiCallStandard";

const getAppIdByUserId = async (id: string) => {
    const URL = `/InspectionUsers/GetAppIdByUserId/${id}`;
    return apiCall('get', URL);
};

const getUserProfile = async () => {
    const URL = `/InspectionUsers/GetUserProfile`;
    return apiCall('get', URL);
};

const getAllInspectionUsers = async (param: any) => {
    const query = `search=${encodeURIComponent(param.search)}&role=${param.role}&status=${param.status}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/InspectionUsers/GetAllUsers?${query}`;
    return apiCall('get', URL);
};

const postInspectionUsers = async (data: any) => {
    const URL = '/InspectionUsers/Create';
    return apiCall('post', URL, data);
};

const registerInspectionUsers = async (data: any) => {
    const URL = '/InspectionUsers/Register';
    return apiCallStandard('post', URL, data);
    // try {
    //     const response = await axiosInstance.post<any[]>(URL, data);
    //     return response;
    // } catch (err: any) {
    //     const obj = {
    //         status: err?.response?.status,
    //         message: err?.response?.data?.message
    //     }
    //     return obj;
    // }
};

const putInspectionUsers = async (data: any) => {
    const URL = '/InspectionUsers/Update';
    return apiCall('post', URL, data);
};

const changePasswordUser = async (data: any) => {
    const URL = '/InspectionUsers/change-password';

    try {
        const response = await axiosInstance.post<any[]>(URL, data);
        return response;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

const requestForgotPassword = async (data: any) => {
    const URL = '/InspectionUsers/request-reset-password';

    try {
        const response = await axiosInstance.post<any>(URL, data);
        return response;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

const resetPassword = async (data: any) => {
    const URL = '/InspectionUsers/reset-password';

    try {
        const response = await axiosInstance.post<any[]>(URL, data);
        return response;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

const deleteInspectionUser = async (id: string, role: string) => {
    const URL = '/InspectionUsers/Delete';
    const data = { id, role };
    return apiCall('post', URL, data);
};

export {
    postInspectionUsers,
    registerInspectionUsers,
    putInspectionUsers,
    getAppIdByUserId,
    getAllInspectionUsers,
    getUserProfile,
    deleteInspectionUser,
    changePasswordUser,
    requestForgotPassword,
    resetPassword
}